import React, { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import { Field } from 'react-final-form';
import { FormattedMessage, useIntl } from '../../../util/reactIntl';
import css from './ApplicationForm.module.css';
import classNames from 'classnames';

const FileDropZone = ({ 
  name,
  input: { value, onChange },
  meta: { touched, error }
}) => {
  const intl = useIntl();
  const uploadedFiles = value || [];

  const onDrop = useCallback((acceptedFiles) => {
    if (acceptedFiles.length > 0) {
      const newFiles = [...uploadedFiles, ...acceptedFiles];
      onChange(newFiles); // Update form field value
    }
  }, [uploadedFiles, onChange]);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: {
      'application/pdf': ['.pdf'],
      'image/*': ['.png', '.jpg', '.jpeg', '.gif'],
      'text/plain': ['.txt'],
      'application/msword': ['.doc'],
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
    },
    multiple: true,
  });

  const removeFile = (index) => {
    const newFiles = uploadedFiles.filter((_, i) => i !== index);
    onChange(newFiles); // Update form field value
  };

  return (
    <div className={css.fileUploadSection}>
      {/* <h3 className={css.fileUploadTitle}>
        <FormattedMessage id="ApplicationForm.fileUploadTitle" />
      </h3>
      <p className={css.fileUploadDescription}>
        <FormattedMessage id="ApplicationForm.fileUploadDescription" />
      </p> */}

      <div
        {...getRootProps()}
        className={classNames(css.dropzone, {
          [css.dropzoneActive]: isDragActive,
        })}
      >
        <input {...getInputProps()} />
        <div className={css.dropzoneContent}>
          <div className={css.dropzoneIcon}>
            <FormattedMessage id="ApplicationForm.dropzoneIcon" />
          </div>
          <p className={css.dropzoneText}>
            {isDragActive ? (
              <FormattedMessage id="ApplicationForm.dropzoneActiveText" />
            ) : (
              <FormattedMessage id="ApplicationForm.dropzoneText" />
            )}
          </p>
          <p className={css.dropzoneHint}>
            <FormattedMessage id="ApplicationForm.dropzoneHint" />
          </p>
        </div>
      </div>

      {touched && error && (
        <div className={css.fieldError}>
          <FormattedMessage id={error} />
        </div>
      )}

      {uploadedFiles.length > 0 && (
        <div className={css.uploadedFiles}>
          <h4>
            <FormattedMessage id="ApplicationForm.uploadedFilesTitle" />
          </h4>
          <div className={css.fileList}>
            {uploadedFiles.map((file, index) => (
              <div key={index} className={css.fileItem}>
                <span className={css.fileName}>{file.name}</span>
                <button
                  type="button"
                  onClick={() => removeFile(index)}
                  className={css.removeFileButton}
                >
                  <FormattedMessage id="ApplicationForm.removeFile" />
                </button>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

// Wrapper component for react-final-form
const FileDropzoneField = ({ name, ...props }) => (
  <Field name={name} component={FileDropZone} {...props} />
);

export default FileDropzoneField; 